import './BoardEffectIcons.css';
import { BOARD_TILE_ABILITIES, getBoardTileAbility } from './doorBoard';
import { getPowerUpMultiplier } from './powerUp';
import CoreboundIcon from './CoreboundIcon';

export const isBoardEffectTile = (square) =>
  ['heal', 'shield'].includes(square?.effect?.type) ||
  !!BOARD_TILE_ABILITIES[square?.effect?.type];

const BoardHeartIcon = ({ className = '' }) => (
  <svg
    className={`coreboundBoardHeartIcon ${className}`}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 21 3.3 12.4C-2.4 6.7 5.7-1.2 12 5.3c6.3-6.5 14.4 1.4 8.7 7.1Z"
      fill="currentColor"
    />
  </svg>
);

export const BoardShieldIcon = ({ className = '' }) => (
  <svg
    className={`coreboundBoardShieldIcon ${className}`}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="m12 2 9 3v7c0 5-5 8-9 10-4-2-9-5-9-10V5Z"
      fill="currentColor"
      fillOpacity="0.24"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M12 6v11M8 10h8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const BoardEffectTile = ({ effect }) => {
  const ability = getBoardTileAbility(effect);
  const powerUp = effect.type === 'powerUp';
  const multiplier = getPowerUpMultiplier(effect);
  return ability ? (
    <span
      className="coreboundBoardUtilityTile"
      data-effect={effect.type}
      data-multiplier={powerUp ? multiplier : undefined}
      title={`${ability.name}: ${ability.description}`}
    >
      <b aria-hidden="true"><CoreboundIcon name={effect.type} /></b>
      <small>
        {powerUp ? (
          <>
            <span className="coreboundPowerUpTileName">POWER UP</span>
            {multiplier > 1 && <span> ×{multiplier}</span>}
          </>
        ) : (
          ability.mini || ability.short
        )}
      </small>
    </span>
  ) : (
    <span className="coreboundBoardEffectTile">
      <b>
        {effect.type === 'heal' ? '+' : ''}
        {effect.amount}
      </b>
      {effect.type === 'heal' ? <BoardHeartIcon /> : <BoardShieldIcon />}
    </span>
  );
};

export const drawBoardHeart = (context, color) => {
  context.save();
  context.translate(88, 20);
  context.scale(80 / 24, 80 / 24);
  context.fillStyle = color;
  context.beginPath();
  context.moveTo(12, 22);
  context.bezierCurveTo(4, 16, 0, 12, 2, 6);
  context.bezierCurveTo(4, 1, 9, 2, 12, 6);
  context.bezierCurveTo(15, 2, 20, 1, 22, 6);
  context.bezierCurveTo(24, 12, 20, 16, 12, 22);
  context.fill();
  context.restore();
};

export const drawBoardShield = (context, color) => {
  context.save();
  context.translate(88, 20);
  context.scale(80 / 24, 80 / 24);
  context.fillStyle = color;
  context.strokeStyle = color;
  context.lineWidth = 1.5;
  context.beginPath();
  context.moveTo(12, 2);
  context.lineTo(21, 5);
  context.lineTo(21, 12);
  context.bezierCurveTo(21, 17, 16, 20, 12, 22);
  context.bezierCurveTo(8, 20, 3, 17, 3, 12);
  context.lineTo(3, 5);
  context.closePath();
  context.globalAlpha = 0.25;
  context.fill();
  context.globalAlpha = 1;
  context.stroke();
  context.beginPath();
  context.moveTo(12, 6);
  context.lineTo(12, 17);
  context.moveTo(8, 10);
  context.lineTo(16, 10);
  context.stroke();
  context.restore();
};
